class Tables {
    constructor(
        name,
        description
    ) {
        this.name = name;
        this.description = description
    }

    static fromJson({
        tabla,
        descripcion
    }) {
        return new Tables(
            tabla,
            descripcion
        );
    }
}

export default Tables;
